export const ACTION_PREFIX = '@@insurance';

export const CARRIER = {
    ILL_CHOOSE_LATER: '-1',
    IM_PAYING_MYSELF: '-2',
    BLUE_CROSS_BLUE_SHIELD: '304',
};

export const ILL_CHOOSE_LATER_TEXT = 'I\'ll choose my insurance later';
export const IM_PAYING_MYSELF_TEXT = 'I\'m paying for myself';
export const IM_PAYING_MYSELF_CAPITALIZED_TEXT = 'I\'m Paying for Myself';

export const INSURANCE_TYPE = {
    DENTAL: 1,
    HEALTH: 2,
    VISION: 3,
};

export const ROOT_STATE_KEY = 'insurance';
